<template>
  <div class="menthu">
    <h5>互联互通</h5>
    <ul>
      <li index="/documenth" @click="goTo('/documenth')">总则</li>
      <li index="/documentj" @click="goTo('/documentj')">公共信息交换规范</li>
      <li index="/documentk" @click="goTo('/documentk')">业务信息交换规范</li>
      <li index="/documentl" @click="goTo('/documentl')">数据传输与安全</li>
    </ul>
  </div>
</template>

<script>
export default {
  methods: {
    goTo(path) {
      this.$router.replace(path);
    },
  },
};
</script>

<style scoped>
h5 {
  width: 262px;
  height: 83px;
  background: #f2f7fb;
  font-size: 22px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  line-height: 83px;
  padding-left: 44px;
}
.menthu{
  margin-top:40px;
}
.menthu ul {
  width: 306px;
  height: 252px;
  background: #f8fbfd;
  text-align: left;
  
}
.menthu ul li {
  margin-left: 44px;
  font-size: 18px;
  font-family: Helvetica;
  color: #191c27;
  line-height: 22px;
  padding-top: 24px;
  cursor: pointer;
}
.menthu ul li:hover {
  color: #0084ff;
}
.menthu ul li:active {
  color: #0084ff;
}
</style>


// WEBPACK FOOTER //
// src/components/menthu.vue